webpackJsonp([3],{

/***/ "./node_modules/hoist-non-react-statics/index.js":
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ }),

/***/ "./src/components/Navigation/navigation.jsx":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _search = __webpack_require__("./src/components/Search/search.jsx");
	
	var _search2 = _interopRequireDefault(_search);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Navigation = function Navigation(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    { className: 'flex flex-column flex-row-ns justify-left w-100 pa3 bg-blue' },
	    _react2.default.createElement(
	      'h1',
	      { className: 'f3 w-100 w-20-ns white lh-title self-center ma0 mb2 ma0-ns' },
	      'CraftBox'
	    ),
	    _react2.default.createElement(_search2.default, null),
	    _react2.default.createElement(
	      'div',
	      { className: 'self-center-ns w-20-ns tl tr-ns' },
	      children
	    )
	  );
	};
	
	exports.default = Navigation;
	
	
	Navigation.propTypes = {
	  children: _react2.default.ReactNode
	};
	
	Navigation.defaultProps = {
	  children: {}
	};
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/Search/search.jsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Search = function (_Component) {
	  _inherits(Search, _Component);
	
	  function Search() {
	    _classCallCheck(this, Search);
	
	    return _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).apply(this, arguments));
	  }
	
	  _createClass(Search, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "w-60-ns w-100 v-mid-l mb2 ma0-ns self-center" },
	        _react2.default.createElement(
	          "fieldset",
	          { className: "cf bn ma0 pa0" },
	          _react2.default.createElement(
	            "div",
	            { className: "cf" },
	            _react2.default.createElement(
	              "label",
	              { className: "clip", htmlFor: "email-address" },
	              "Email Address"
	            ),
	            _react2.default.createElement("input", { className: "f6 f5-l input-reset bn fl black-80 bg-white pa2 lh-solid w-80 br2-ns br--left-ns", placeholder: "Search", type: "text" }),
	            _react2.default.createElement("input", { className: "f6 f5-l button-reset fl pv2 tc bn bg-animate bg-black-70 hover-bg-black white pointer w-20 br2-ns br--right-ns", type: "submit", value: "Go" })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Search;
	}(_react.Component);
	
	exports.default = Search;
	module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/home/travis/build/undertideco/craftbox/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/home/travis/build/undertideco/craftbox/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/home/travis/build/undertideco/craftbox/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/home/travis/build/undertideco/craftbox/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[\"/home/travis/build/undertideco/craftbox/node_modules/babel-preset-env/lib/index.js\",\"/home/travis/build/undertideco/craftbox/node_modules/babel-preset-stage-0/lib/index.js\",\"/home/travis/build/undertideco/craftbox/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/layouts/index.jsx":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _navigation = __webpack_require__("./src/components/Navigation/navigation.jsx");
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template() {
	    _classCallCheck(this, Template);
	
	    return _possibleConstructorReturn(this, (Template.__proto__ || Object.getPrototypeOf(Template)).apply(this, arguments));
	  }
	
	  _createClass(Template, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'root-container' },
	        _react2.default.createElement(
	          _navigation2.default,
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: 'f6 fw4 hover-white no-underline white-70 pr2', to: '/' },
	            'Catalog'
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: 'f6 fw4 hover-white no-underline white-70 pr2', to: '/product' },
	            'Inspiration'
	          )
	        ),
	        this.props.children()
	      );
	    }
	  }]);
	
	  return Template;
	}(_react2.default.Component);
	
	exports.default = Template;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// layout-component---index-82f79a011b2b1684356d.js